module.exports = __webpack_public_path__ + "static/media/1.6d2da0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/1.png
// module id = 1049
// module chunks = 0